export const AUTH_SECURE_STORAGE_USER_KEY: string = 'userResponse';
export const AUTH_LEGACY_LOCAL_STORAGE_USER_KEY: string = 'userResponse';
